import { useEffect } from "react";

const GoogleAnalytics = () => {
  const trackingId = process.env.REACT_APP_GA_TRACKING_ID || "";

  useEffect(() => {
    const script1 = document.createElement("script");
    script1.src = `https://www.googletagmanager.com/gtag/js?id=${trackingId}`;
    script1.async = true;
    document.head.appendChild(script1);

    const script2 = document.createElement("script");
    script2.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${trackingId}', { page_path: window.location.pathname });
    `;
    document.head.appendChild(script2);
  }, [trackingId]);

  return null;
};

export default GoogleAnalytics;
